import { Logger } from '@/shared/logger/logger';
import { EBundleName } from '@/sources';

import { TagManagerWrapper } from '.';
import { TGtagInitConfig } from './types';

// Subclass for Server-Side Google Tag Manager
export class SGTMWrapper extends TagManagerWrapper {
  constructor(dataLayerName = 'sgtmLayer', gtagFunctionName = 'sgtmTag') {
    super(dataLayerName, gtagFunctionName);
  }

  public initSGTM(
    gaMeasurementId: string,
    sgtmContainerUrl: string,
    sgtmAdwordsId: string,
    config: TGtagInitConfig = {},
  ): void {
    if (!this.isValidId(gaMeasurementId, /^G-/)) {
      throw new Error(`Invalid GA4 Measurement ID ${gaMeasurementId}`);
    }

    if (!sgtmContainerUrl) {
      throw new Error('SGTM Container URL is required');
    }

    this.loadGtagScript(gaMeasurementId, sgtmContainerUrl, false, true);

    this.gtagFunction('config', gaMeasurementId, {
      debug_mode: config.debug_mode,
      send_page_view: Logger.bundleName === EBundleName.SHOPIFY_CUSTOM_PIXEL,
      transport_url: sgtmContainerUrl,
      ...config,
    });

    this.gtagFunction('config', sgtmAdwordsId, {
      debug_mode: config.debug_mode,
      transport_url: sgtmContainerUrl,
    });

    this.initConsent();
  }
}
